import React, { useState } from 'react';

const COLORS = {
  blue: '#1F4E8C', green: '#3B6D11', lgreen: '#EAF3DE', bgreen: '#C0DD97',
  red: '#A32D2D', lred: '#FCEBEB', bred: '#F7C1C1',
};

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://aaktradex.in/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('role', data.role);
        localStorage.setItem('username', data.username);
        onLogin(data);
      } else {
        setError(data.detail || 'Invalid credentials');
      }
    } catch (e) {
      setError('Connection error. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F1EFE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#ffffff', borderRadius: 16, padding: '40px 36px', width: 360, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: COLORS.blue, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 24 }}>📈</div>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#2C2C2A', marginBottom: 4 }}>AAKTradeX</div>
          <div style={{ fontSize: 13, color: '#888780' }}>Automated Trading System</div>
        </div>

        {error && (
          <div style={{ background: COLORS.lred, border: `0.5px solid ${COLORS.bred}`, borderRadius: 8, padding: '10px 12px', marginBottom: 16, fontSize: 13, color: COLORS.red }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 500, color: '#5F5E5A', display: 'block', marginBottom: 6 }}>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '0.5px solid #D3D1C7', fontSize: 14, outline: 'none', background: '#F8F7F4', color: '#2C2C2A' }}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, fontWeight: 500, color: '#5F5E5A', display: 'block', marginBottom: 6 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '0.5px solid #D3D1C7', fontSize: 14, outline: 'none', background: '#F8F7F4', color: '#2C2C2A' }}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '11px', borderRadius: 8, border: 'none', background: loading ? '#888780' : COLORS.blue, color: '#ffffff', fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: '#888780' }}>
          🔒 Secured by SSL | Private system
        </div>
      </div>
    </div>
  );
}
